import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "./AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, Spinner } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/formatError";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate(location.state?.from || "/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiError(err, "Login failed."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back. Enter your details to continue."
      footer={<>New to Wappy? <Link to="/signup" className="link font-medium">Create a workspace</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email">
          <Input type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="login-email-input" />
        </Field>
        <Field label={<span className="flex items-center justify-between">Password <Link to="/forgot-password" className="text-xs font-normal text-primary hover:underline">Forgot password?</Link></span>}>
          <Input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        </Field>
        {error && <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full" data-testid="login-submit-button">
          {loading && <Spinner className="text-white" />} Sign in
        </Button>
      </form>
    </AuthLayout>
  );
}
